/* eslint-disable */

import React, { useEffect, useState, useRef } from "react";
import Modal from "react-modal";
import H2 from "components/H2";
import H4 from "components/H4";
import DropdownV2 from "components/DropdownV2";

import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom";
const Icon = styled.img``;
import Svg from "_assets/svg";
import "../wa_template.scss";

// services
import waTemplateSvc from "services/waTemplateSvc";
import applicationSvc from "services/applicationSvc";
import PhoneMediaPreview from "../PhoneMediaPreview";

// image
import ItalicImage from '../../../_assets/svg/italic.svg';
import Boldmage from '../../../_assets/svg/bold.svg';
import IconImage from '../../../_assets/svg/iconText.svg';
import AlertTriangle from '../../../_assets/svg/alert-triangle.svg';
import BadgeInfo from '../BadgeInfo';
import {Alert, AlertType } from "utils/Alert";


const ButtonProject = styled.div`
  /* Rectangle 99 */
  // margin: 8px;

  // padding: 10px;
  display: flex;
  // flex-direction: row;
  justify-content: space-between;
  align-items: center;

  background: #f8f8f9;
  opacity: 0.8;
  border: 1px solid #d8dce1;
  box-sizing: border-box;
  border-radius: 8px;
  &:focus {
    outline: none;
  }

  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  cursor: pointer;
`;

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40vw",
  },
};

function CreateTemplateWa() {
  const history = useHistory();
  const location = useLocation();
  const [dropdown, setDropdown] = useState(false);
  const [dropdownButtons, setDropdownButtons] = useState(false);
  const [isOptionMedia, setOptionMedia] = useState("");
  const [isOptionButtons, setOptionButtons] = useState("");
  const [isTitle, setTitle] = useState("Create Template");
  const [isTemplate_name, setTemplate_name] = useState("");
  const [isPreview, setPreview] = useState({});
  const [isHeaderPhone, setHeaderPhone] = useState({ type: "", text: "", body: "" });
  const [isHeaderPayload, setHeaderPayload] = useState({ type: "none", text: "", body: "" });
  const [isBodyTemplate, setBodyTemplate] = useState("");
  const [isMessage, setMessage] = useState("");
  const [isPrefButton, setPrefButton] = useState([]);
  const [isDataVariable, setDataVariable] = useState([]);
  const [isErrorTemplateName, setErrorTemplateName] = useState(false);
  const [isErrorButtonText, setErrorButtonText] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);
  const [isDataPost, setDataPost] = useState(null);
  const [alertDraft, setAlertDraft] = useState(false);
  const [isApplicatoinId, setApplicationId] = useState([]);
  const [isAnyDataTemplate, setAnyDataTemplate] = useState([]);
  const [isDataOnBoarding, setDataOnBoarding] = useState();

  const opsiHeader = [
    {
      name: "None",
      value: "none",
    },
    {
      name: "Media",
      value: "media",
    },
    {
      name: "Text",
      value: "text",
    },
  ];
  const opsiButton = [
    {
      name: "None",
      value: "none",
    },
    {
      name: "Quick Reply",
      value: "quick_reply",
    },
    {
      name: "Call To Action",
      value: "call_to_action",
    },
  ];

  let template_name = "";
  let dataTemplate;
  let prevButtons = [];
  let header = { type: "", text: "" };
  let type_header = "";
  let type_button = "";
  let def_header;
  let def_button;
  let flagBtn = 0;
  let body_template = "";
  let preview;

  useEffect(() => {
    getAllData();
  }, []);

  
useEffect(()=>{
  if(location?.state?.dataChooseTypeTemplate){
    setDataOnBoarding(location?.state?.dataChooseTypeTemplate)
    setTemplate_name(location?.state?.dataChooseTypeTemplate?.templateName)
    console.log('location', location)
  }
}, [location])

  async function getAllData() {
    let res = await applicationSvc.getAll();

    if (res.data.data) {
      let data = [];
      res?.data?.data.forEach((element) => {
        data.push(element._id);
      });
      setApplicationId(data);
      getDataTemplate();
      getVariables();
    }
  }

  async function getDataTemplate() {
    let _id = location?.state?.id;
    
    if (_id != undefined && _id) {
      setTitle("Edit Template");
      await waTemplateSvc
        .getDetailTemplate(_id)
        .then((res) => {
          if (
            res.data.data.request_status == "Draft" ||
            res.data.data.request_status == "Rejected"
          ) {
            setAnyDataTemplate([res.data.data]);

            let temp_name = res.data.data.template_name;
            template_name = temp_name
              .replace(/ /g, "_")
              .replace(/[^a-zA-Z0-9_]/g, "")
              .toLowerCase();
            setTemplate_name(
              temp_name
                .replace(/ /g, "_")
                .replace(/[^a-zA-Z0-9_]/g, "")
                .toLowerCase()
            );
            // this.template_name = name.replace(/ /g, "_").replace(/[^a-zA-Z0-9_]/g, "").toLowerCase();

            // buttons
            if (res.data.data.button.length > 0) {
              prevButtons = res.data.data.button.map((el) => {
                return {
                  type: el.type,
                  index: el.button_index,
                  display: el.button_info.button_text,
                  content: el.button_info.url,
                };
              });
              let dataButtons = [];
              res.data.data.button.map((el) => {
                dataButtons.push({
                  type: el.type,
                  index: el.button_index,
                  display: el.button_info.button_text,
                  content: el.button_info.url,
                });
              });

              setPrefButton(dataButtons);

              if (prevButtons[0].type == "quick_reply") {
                def_button = opsiButton[1];
                type_button = opsiButton[1].value;

                setOptionButtons(opsiButton[1]);
              } else {
                def_button = opsiButton[2];
                type_button = opsiButton[2].value;

                setOptionButtons(opsiButton[2]);
              }
            }
            if (!type_button) {
              flagBtn = 1;
            }

            // header
            header = { type: res.data.data.header.type, text: "" };
            // setHeader({ type: res.data.data.header.type, text: '' });
            if (header.type == "text") {
              header.text = res.data.data.header.text.body;
              setHeaderPhone(header);

              type_header = opsiHeader[2].value;
              def_header = opsiHeader[2];

              setOptionMedia(opsiHeader[2]);
            } else if (header.type != "none") {
              type_header = opsiHeader[1].value;
              def_header = opsiHeader[1];
              setHeaderPhone(header);
              setOptionMedia(opsiHeader[1]);
            }
            // media
            // body_template = decodeURI(res.data.data.body);
            body_template = res.data.data.body;
            setBodyTemplate(body_template);
            setBodyMessage(body_template);

            setPreview({
              footer: prevButtons,
              header: header,
              message: isMessage.trim(),
            });
          } else {
            history.push("/whatsapp-template/create");
          }
        })
        .catch((error) => {
          Alert.showStatus(
            'error',
            'Error',
            error?.message
          )
          history.push("/whatsapp-template/create");
        });
    } else {
      flagBtn = 1;
    }
  }

  function checkValidName(ev) {
    setTemplate_name(
      ev
        .replace(/ /g, "_")
        .replace(/[^a-zA-Z0-9_]/g, "")
        .toLowerCase()
    );
  }

  async function onCheckTemplate(ev) {
    if (ev) {
      await waTemplateSvc
        .getTemplateName(ev, isApplicatoinId[0])
        .then((result) => {
          if (result.data.data.available) {
            setErrorTemplateName(false);
          } else {
            setErrorTemplateName(true);
          }
        })
        .catch((error) => { });
    }
  }

  const initialValidation = {
    template_name: { isValid: true, msg: "" },
    header: { isValid: true, msg: "" },
    body: { isValid: true, msg: "" },
    footer: { isValid: true, msg: "" },
  };

  const [validation, setValidation] = useState();

  const validateForm = () => {
    let validationForm = initialValidation;

    if (!isTemplate_name) {
      validationForm = {
        ...validationForm,
        template_name: {
          ...validationForm.template_name,
          isValid: false,
          msg: "Template Name is required",
        },
      };
    }

    if (isErrorTemplateName) {
      validationForm = {
        ...validationForm,
        template_name: {
          ...validationForm.template_name,
          isValid: false,
          msg: "Template Not Valid",
        },
      };
    }

    // if (!onCheckTemplate(isTemplate_name)) {
    //   validationForm = {
    //     ...validationForm,
    //     template_name: { ...validationForm.template_name, isValid: false, msg: "Template Name is required" },
    //   };
    // }

    // if (!isHeaderPhone?.type) {
    //   validationForm = {
    //     ...validationForm,
    //     header: { ...validationForm.header, isValid: false, msg: "Header is required" },
    //   };
    // }

    if (!isBodyTemplate) {
      validationForm = {
        ...validationForm,
        body: { ...validationForm.body, isValid: false, msg: "Body is required" },
      };
    }

    // if (useRefButtons.current.length === 0) {
    //   validationForm = {
    //     ...validationForm,
    //     footer: { ...validationForm.footer, isValid: false, msg: "Footer is required" },
    //   };
    // }

    for (let index = 0; index < useRefButtons.current.length; index++) {
      if (!useRefButtons.current[index].display) {
        validationForm = {
          ...validationForm,
          footer: { ...validationForm.footer, isValid: false, msg: "Footer is required" },
        };
      }
    }

    setValidation(validationForm);

    let result = true;
    Object.entries(validationForm).forEach(([key, { isValid }]) => {
      if (!isValid) result = false;
    });
    return result;
  };

  let statusPost;
  async function handleSubmit(status) {
    const isValid = validateForm();

    if (!isValid) {
      return;
    }
    statusPost = status;
    // const val = valForm.value;
    let dataPost;
    let buttons;
    // buttons

    buttons = isPrefButton.map((el) => {
      if (el.display) {
        const eldata = {
          type: el.type,
          button_index: el.index,
          button_info: {
            button_text: el.display,
          },
        };
        if (el.type == "url" && el.content) {
          eldata.button_info["url"] = el.content;
        }
        return eldata;
      }
    });
    if (buttons[0] == null) {
      buttons = {};
    }

    // header
    // if (isOptionMedia.value == 'media') {
    //   if (isHeader.media == 'image') {
    //     setHeader({ type: 'image', image: { link: '' } });
    //   } else if (isHeader.media == 'document') {
    //     setHeader({ type: 'document', document: { link: '' } });
    //   } else if (isHeader.media == 'location') {
    //     setHeader({ type: 'location', location: { link: '' } });
    //   } else if (isHeader.media == 'video') {
    //     setHeader({ type: 'video', video: { link: '' } });
    //   }
    // } else if (isOptionMedia.value == 'text') {
    //   setHeader({ type: 'text', text: { body: isHeader.body } });
    // console.log('dataPost',isHeader)

    // } else {
    //   setHeader({ type: 'none' });
    // }

    // result data for post
    if (isAnyDataTemplate.length > 0) {
      dataPost = {
        template_name: isTemplate_name,
        header: isHeaderPayload,
        body: encodeURI(isBodyTemplate.trim()),
        button: buttons,
        template_category: isAnyDataTemplate[0]?.template_category ? isAnyDataTemplate[0]?.template_category : '-',
        language: isAnyDataTemplate[0]?.language ? isAnyDataTemplate[0]?.language : '-',
      };
    } else {
      dataPost = {
        application_id: isApplicatoinId[0],
        template_name: isTemplate_name,
        header: isHeaderPayload,
        body: encodeURI(isBodyTemplate.trim()),
        button: buttons,
        template_category: isDataOnBoarding?.category?.value,
        language: isDataOnBoarding?.language?.value,
      };
    }
    if (status == "draft") {
      dataOnPost({ dataPost: dataPost, status: status });
    } else if (status == "save") {
      setOpenModal(true);
      setDataPost({ dataPost: dataPost, status: status });
    }
  }

  async function dataOnPost(data) {
    console.log('dataa', data, isAnyDataTemplate)
    // this.isLoading = true;
    let _id = location?.state?.id;

    if (isAnyDataTemplate.length > 0) {
      // UPDATE
      await waTemplateSvc
        .updateTemplate({ template_id: _id, status: data.status }, data.dataPost)
        .then((obj) => {
          console.log('obj', obj)
          if(obj.data.success){
            if (data.status == "draft") {
              Alert.showStatus(
                AlertType.SUCCESS,
                'Success!',
                'WhatsApp template successfully drafted.'
              )
            } else if (data.status == "save") {
              Alert.showStatus(
                AlertType.SUCCESS,
                'Success!',
                'WhatsApp template successfully created.'
              )
              setOpenModal(false);
              // Alert.showToastConfirm(
              //   APP_SETTING.ALERT_SUCCESS_IMAGE,
              //   APP_SETTING.ALERT_SUCCESS,
              //   'WhatsApp template successfully created. Please contact our support for approval template',
              //   'Contact Support',
              //   'Later',
              //   () => {
              //     window.open('https://api.whatsapp.com/message/CJYNUR2AAUSVG1');
              //   },
              //   () => { }
              // );
            }
          }else{
            Alert.showStatus(
              'error',
              'Error',
              obj.data.errors.message
            )
          }
          setTimeout(() => {
            history.push("/whatsapp-template");
          }, 1500);
        })
        .catch((error) => {
          Alert.showStatus(
            'error',
            'Error',
            error?.message
          )
        });
    } else {
      // POST
      await waTemplateSvc
        .createTemplate(data.status, data.dataPost)
        .then((obj) => {
          if(obj.data.success){
            if (data.status == "draft") {
              Alert.showStatus(
                AlertType.SUCCESS,
                'Success!',
                'WhatsApp template successfully drafted.'
              )
            } else if (data.status == "save") {
              Alert.showStatus(
                AlertType.SUCCESS,
                'Success!',
                'WhatsApp template successfully created.'
              )
              setOpenModal(false);
              // Alert.showToastConfirm(
              //   APP_SETTING.ALERT_SUCCESS_IMAGE,
              //   APP_SETTING.ALERT_SUCCESS,
              //   'WhatsApp template successfully created. Please contact our support for approval template',
              //   'Contact Support',
              //   'Later',
              //   () => {
              //     window.open('https://api.whatsapp.com/message/CJYNUR2AAUSVG1');
              //   },
              //   () => { }
              // );
            }
          }else{
            Alert.showStatus(
              'error',
              'Error',
              obj.data.errors.message
            )
          }
          setTimeout(() => {
            history.push("/whatsapp-template");
          }, 1500);
        })
        .catch((error) => {
          Alert.showStatus(
            'error',
            'Error',
            error?.message
          )
        });
    }
  }

  function handlesetOptionButtons(val) {
    if(val.value === 'none'){
      setOptionButtons(val);
      setPrefButton([]);
    }else{
      setOptionButtons(val);
      setPrefButton([
        {
          type: "",
          index: 0,
          display: "",
          content: "",
        },
      ]);
    }
    setDropdownButtons(false);
  }

  const useRefButtons = useRef();
  useRefButtons.current = isPrefButton;

  function setChangeButtonOptions(event) {
    let newData = [];
    newData.push(...isPrefButton);
    newData[event.index].display = event.display;
    newData[event.index].index = event.index;
    newData[event.index].content = event.content;
    newData[event.index].type = isOptionButtons.value;
    if (isOptionButtons.value === "call_to_action") {
      newData[event.index].type = "url";
    }

    setPrefButton(newData);

    setPreview({
      footer: useRefButtons.current,
      header: isHeaderPhone,
      message: isMessage.trim(),
    });
  }

  function handleAddOtherButton() {
    for (let index = 0; index < isPrefButton.length; index++) {
      if (!isPrefButton[index].display) {
        setErrorButtonText(true);
      } else {
        setErrorButtonText(false);

        if (isPrefButton.length < 3) {
          let newData = [];
          newData.push(...isPrefButton);
          newData.push({
            type: "",
            index: "",
            display: "",
            content: "",
          });

          setPrefButton(newData);
        }
      }
    }
  }

  const useRefHeaderPhone = useRef();
  useRefHeaderPhone.current = isHeaderPhone;
  const isOptionMediaRef = useRef();
  isOptionMediaRef.current = isOptionMedia;

  function handleHeader(val) {
    if (isOptionMedia.value == "media") {
      setHeaderPhone({ type: val.type, text: val.text, body: val.text });
    }

    if (isOptionMedia.value == "text") {
      setHeaderPhone({ type: val.type, text: val.text, body: val.text });
    }

    if (isOptionMediaRef.current.value == "media") {
      if (val.type == "image") {
        setHeaderPayload({ type: "image", image: { link: "" } });
      } else if (val.type == "document") {
        setHeaderPayload({ type: "document", document: { link: "" } });
      } else if (val.type == "location") {
        setHeaderPayload({ type: "location", location: { link: "" } });
      } else if (val.type == "video") {
        setHeaderPayload({ type: "video", video: { link: "" } });
      }
    } else if (isOptionMediaRef.current.value == "text") {
      setHeaderPayload({ type: "text", text: { body: val.text } });
    } else {
      setHeaderPayload({ type: "none", type: 'none' });
    }
  }

  let appIdRef = useRef();
  appIdRef.current = isApplicatoinId;
  function getVariables() {
    let appId = appIdRef.current[0];
    waTemplateSvc
      .getVariableList(appId)
      .then((result) => {
        setDataVariable(result.data.data);
      })
      .catch((error) => { });
  }

  const texAreaRef = useRef();
  let maxLengthTextArea = 1024;
  let arrVariable = [];
  let textBody;
  let personalize;

  function handleAaddVariable(value) {
    addVariable(texAreaRef, value, maxLengthTextArea, texAreaRef?.current?.selectionStart);
  }

  function addVariable(template, value, length, indexStart) {
    let val;
    // let indexStart ;
    const el = template.current;
    val = el?.value;
    indexStart = el?.selectionStart;
    if (val?.length < length) {
      let newValue = val.slice(0, indexStart) + "[" + value + "]" + val.slice(indexStart);
      if (arrVariable.includes(value)) {
        arrVariable.push(value);
      }

      textBody = newValue;
      personalize = arrVariable;

      setBodyTemplate(textBody);
      setBodyMessage(textBody);
    }
  }

  function handleInsertSymbol(symbol) {
    let indexStart;
    let indexEnd;
    let val;
    let res;

    const el = texAreaRef?.current;
    val = el?.value;
    indexStart = texAreaRef?.current?.selectionStart;
    indexEnd = texAreaRef?.current?.selectionEnd;
    res = val.substring(indexStart, indexEnd);

    if (res) {
      let data = val.slice(0, indexStart) + symbol + res + symbol + val.slice(indexEnd);
      setBodyTemplate(val.slice(0, indexStart) + symbol + res + symbol + val.slice(indexEnd));
    } else {
      let data =
        val.slice(0, indexStart) +
        " " +
        symbol +
        "fill-text" +
        symbol +
        " " +
        val.slice(indexStart);
      setBodyTemplate(
        val.slice(0, indexStart) + " " + symbol + "fill-text" + symbol + " " + val.slice(indexStart)
      );
    }
  }

  function setBodyMessage(message) {
    let brackets = false;
    let underscores = [];
    let newText = message;
    for (let i = 0; i < message.length; i++) {
      const char = newText[i];
      if (char === "[") {
        brackets = true;
      }
      if (newText[i] === "_" && brackets) {
        underscores.push(i);
      }
      if (newText[i] === "]") {
        brackets = false;
      }
    }

    underscores.reverse();
    underscores.forEach((element) => {
      newText = setCharAt(newText, element, "&#95;");
    });
    setBodyTemplate(message);
    setMessage(newText);
  }

  function setCharAt(str, index, chr) {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
  }

  function handleSelectHeader(item){
    setHeaderPhone({ type: '', text: '', body: '' });
    setHeaderPayload({ type: 'none', text: '', body: '' });

    setOptionMedia(item);
  }

 
  useEffect(() => {
    setPreview({
      footer: useRefButtons.current.length > 0 ? useRefButtons.current : [],
      header: useRefHeaderPhone.current,
      message: decodeURI(isMessage.trim()),
    });
  }, [isBodyTemplate, isHeaderPhone, useRefButtons.current, useRefHeaderPhone.current, isOptionMedia, isMessage]);

  return (
    <div
      className="wrapper_template_wa d-flex flex-column container-fluid no-pad"
      style={{ height: "100%" }}
    >
      <Modal
        isOpen={isOpenModal}
        // onRequestClose={()=>setOpenModal(false)}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="modal-submit mb-2">
          <div className="title mb-1">Is the template you want to submit correct?</div>
          <div className="wording">
            Make sure the template you submitted does not contain inappropriate or unlawful words in
            Indonesia. For more details please read the Terms and Conditions of WhatsApp broadcast.
          </div>
        </div>
        {/* <div className='button-modal-submit'>
          <div onClick={()=>dataOnPost(isDataPost)}>Yes, Submit</div>
          <div onClick={()=>setOpenModal(false)}>I'm not sure</div>
        </div> */}
        <div className="d-flex align-items-center justify-content-center mt-4">
          <div onClick={() => setOpenModal(false)} className="me-3 btn-secondary-template">
            I'm not sure
          </div>
          <div onClick={() => dataOnPost(isDataPost)} className="btn-primary-template">
            Yes, Submit
          </div>
        </div>
      </Modal>
      <div className="d-flex flex-row align-items-end justify-content-between mb-4">
        <div className="d-flex flex-column">
          <H2 color="#091E42">{isTitle}</H2>
          <div className="breadcrumb_create_template_wa">
            <span onClick={() => history.push("/whatsapp-template")} className="first">
              WhatsApp Template List
            </span>{" "}
            <span className="mx-2">></span>{" "}
            <span className="second">{location?.state?.id ? 'Form Edit Template WhatsApp' : 'Form Create Template WhatsApp'}</span>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <div onClick={() => handleSubmit("draft")} className="me-4 mb-2 btn-secondary-template">
            Save as Draft
          </div>
          <div onClick={() => handleSubmit("save")} className="mb-2 btn-primary-template">
            Submit
          </div>
        </div>
      </div>
      <div className='my-0'>
        <BadgeInfo></BadgeInfo>
      </div>
      <div className="row form-fields">
        <div className="col-xl-8 col-md-7 pr-xl-4">
          <div className="mb-4 pb-3" style={{ position: "relative" }}>
            <H4 color="#42526E" fontWeight="700" className="cl-neutral400 mb-2">
              Template Name/Display Name{" "}
            </H4>
            <div className="input-group">
              <input
                required={true}
                type="text"
                value={isTemplate_name}
                onChange={(e) => checkValidName(e.target.value)}
                onKeyUp={(e) => onCheckTemplate(e.target.value)}
                placeholder="Example: Template WhatsApp Blast Januari"
                error=""
                className="form-control cl-neutral100"
              />
            </div>
            <div
              className={`${isErrorTemplateName ? "" : "d-none"
                } d-flex align-items-center mt-3 box-info info-required`}
            >
              <img src={AlertTriangle}></img>
              <span className="ms-2">
                Template name is already used. Please use other template name!
              </span>
            </div>
          </div>
          <div className="wrapper_input_template mb-4 pb-3" style={{ position: "relative" }}>
            <div className="d-flex align-items-center mb-2">
              <H4 color="#42526E" fontWeight="700" className="cl-neutral400">
                Header
              </H4>
              <div className="optional ms-2 cl-neutral100">Optional</div>
            </div>
            <div className="cl-neutral100 mb-3" style={{ fontSize: "14px" }}>
              Add a title or choose which type of media you'll use for this header.
            </div>
            <div className="d-flex align-items-center">
              <div className="me-4">
                <ButtonProject
                  style={{ width: "150px" }}
                  onClick={() => {
                    setDropdown(!dropdown);
                  }}
                >
                  <label className="margin-right-10 styleDropdwown">
                    {isOptionMedia ? isOptionMedia.name : "None"}
                  </label>
                  <Icon src={Svg.chevron_right_2.default} />
                </ButtonProject>
                {dropdown && (
                  <DropdownV2
                    styleDropdwown="styleDropdwown"
                    data={opsiHeader}
                    handleClick={(i) => {
                      handleSelectHeader(i)
                      setDropdown(false);
                    }}
                  />
                )}
              </div>
              {/* header text */}
              {isOptionMedia.value === "text" && (
                <div className="w-100 wrapper_input_count">
                  <div className="input-group">
                    <input
                      style={{ borderRadius: "5px", paddingRight: "2rem" }}
                      required={true}
                      defaultValue={isHeaderPhone.text}
                      onChange={(e) => handleHeader({ type: "text", text: e.target.value })}
                      type="text"
                      placeholder="Enter text here"
                      error=""
                      className="form-control cl-neutral100"
                      maxLength={60}
                    />
                    <span className="count-char">{isHeaderPayload?.text?.body?.length}/60</span>
                  </div>
                </div>
              )}
            </div>
            {/* mediaa */}
            {isOptionMedia.value === "media" && (
              <div className="row mt-4">
                <div className="col-xl-3 col-6">
                  <div
                    className="opsi-media"
                    className={`${isHeaderPhone.type == "image" ? "opsi-media choosen" : "opsi-media"
                      }`}
                  >
                    <div className="bullet-circle"></div>
                    <input
                      type="radio"
                      name="media"
                      value={isHeaderPhone.type}
                      onChange={(e) =>
                        handleHeader({ type: "image", text: "", image: { link: "" } })
                      }
                    />
                    <div className="icon-media">
                      <svg
                        width="72"
                        height="72"
                        viewBox="0 0 72 72"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M57 9H15C11.6863 9 9 11.6863 9 15V57C9 60.3137 11.6863 63 15 63H57C60.3137 63 63 60.3137 63 57V15C63 11.6863 60.3137 9 57 9Z"
                          stroke="#B3BAC5"
                          strokeWidth="4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M25.5 30C27.9853 30 30 27.9853 30 25.5C30 23.0147 27.9853 21 25.5 21C23.0147 21 21 23.0147 21 25.5C21 27.9853 23.0147 30 25.5 30Z"
                          stroke="#B3BAC5"
                          strokeWidth="4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M63 45L48 30L15 63"
                          stroke="#B3BAC5"
                          strokeWidth="4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          className="fill"
                          d="M16.5 62L48 30L62.5 44.5V62H16.5Z"
                          fill="#B3BAC5"
                        />
                      </svg>
                      <span className="label-media">Image</span>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-6">
                  <div
                    className="opsi-media"
                    className={`${isHeaderPhone.type == "video" ? "opsi-media choosen" : "opsi-media"
                      }`}
                  >
                    <div className="bullet-circle"></div>
                    <input
                      type="radio"
                      name="media"
                      value={isHeaderPhone.type}
                      onChange={(e) =>
                        handleHeader({ type: "video", text: "", video: { link: "" } })
                      }
                    />
                    <div className="icon-media">
                      <svg
                        width="72"
                        height="72"
                        viewBox="0 0 72 72"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle className="fill" cx="36" cy="36" r="27" fill="#B3BAC5" />
                        <path
                          d="M46.5 35.134C47.1667 35.5189 47.1667 36.4811 46.5 36.866L31.5 45.5263C30.8333 45.9112 30 45.4301 30 44.6603L30 27.3397C30 26.5699 30.8333 26.0888 31.5 26.4737L46.5 35.134Z"
                          fill="white"
                        />
                      </svg>
                      <span className="label-media">Video</span>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-6 mt-xl-0 mt-3">
                  <div
                    className={`${isHeaderPhone.type == "document" ? "opsi-media choosen" : "opsi-media"
                      }`}
                  >
                    <div className="bullet-circle"></div>
                    <input
                      type="radio"
                      name="media"
                      value={isHeaderPhone.type}
                      onChange={(e) =>
                        handleHeader({ type: "document", text: "", document: { link: "" } })
                      }
                    />
                    <div className="icon-media">
                      <svg
                        width="72"
                        height="72"
                        viewBox="0 0 72 72"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          className="fill"
                          x="13"
                          y="9"
                          width="46"
                          height="54"
                          rx="5"
                          fill="#B3BAC5"
                        />
                        <rect x="19" y="17" width="34" height="4" rx="2" fill="white" />
                        <rect x="19" y="26" width="34" height="4" rx="2" fill="white" />
                        <rect x="19" y="35" width="27" height="4" rx="2" fill="white" />
                      </svg>
                      <span className="label-media">Document</span>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-6 mt-xl-0 mt-3">
                  <div
                    className={`${isHeaderPhone.type == "location" ? "opsi-media choosen" : "opsi-media"
                      }`}
                  >
                    <div className="bullet-circle"></div>
                    <input
                      type="radio"
                      name="media"
                      value={isHeaderPhone.type}
                      onChange={(e) =>
                        handleHeader({ type: "location", text: "", location: { link: "" } })
                      }
                    />
                    <div className="icon-media">
                      <svg
                        width="72"
                        height="72"
                        viewBox="0 0 72 72"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          className="fill"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M36 63C39 61.6364 57.5455 43.1503 57.5455 31C57.5455 18.8497 47.8992 9 36 9C24.1008 9 15 18.9406 15 31.0909C15 43.2412 32.7273 61.3636 36 63ZM36.2727 39C40.7914 39 44.4545 35.3369 44.4545 30.8182C44.4545 26.2995 40.7914 22.6364 36.2727 22.6364C31.754 22.6364 28.0909 26.2995 28.0909 30.8182C28.0909 35.3369 31.754 39 36.2727 39Z"
                          fill="#B3BAC5"
                        />
                      </svg>
                      <span className="label-media">Location</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="mb-4 pb-3" style={{ position: "relative" }}>
            <div className="d-flex align-items-center mb-2">
              <H4 color="#42526E" fontWeight="700" className="cl-neutral400">
                Body
              </H4>
            </div>
            <div className="cl-neutral100 mb-3" style={{ fontSize: "14px" }}>
              Enter the text for your message in the language you've selected.
            </div>
            <div className="w-100 wrapper_count_textarea">
              <div className="input-group">
                <span className="length_count">{isBodyTemplate?.length}/1024</span>
                <textarea
                  ref={texAreaRef}
                  required={true}
                  type="text"
                  placeholder="Example: Template WhatsApp Blast Januari"
                  value={isBodyTemplate}
                  onChange={(e) => setBodyMessage(e.target.value)}
                  error=""
                  className="form-control cl-neutral100"
                  rows={7}
                  maxLength={1024}
                />
              </div>
              <div className="form-group mt-3 mb-md-2 mb-3">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center">
                    <span className="count_text"> Characters: {isBodyTemplate?.length}/1024</span>
                  </div>
                  <div className="d-flex align-items-center">
                    {/* <img onClick={()=>handleInsertSymbol('*')} src={IconImage} className="ms-3 btn-editor"></img> */}
                    <img
                      onClick={() => handleInsertSymbol("*")}
                      src={Boldmage}
                      className="ms-3 btn-editor"
                    ></img>
                    <img
                      onClick={() => handleInsertSymbol("_")}
                      src={ItalicImage}
                      className="ms-3 btn-editor"
                    ></img>
                    <div className="add_variable ms-3 d-none">+ Add Variable</div>
                  </div>
                </div>
                <div className="personalize-items mt-1">
                  {isDataVariable &&
                    isDataVariable.map((res, index) => {
                      return (
                        <div key={index}>
                          <div
                            className="wrap-variable"
                            onClick={() => handleAaddVariable(res?.variable_name)}
                          >
                            <span className="ic-plus">+</span> {res?.field_name}
                          </div>
                        </div>
                      );
                    })}
                  {/* <div className="wrap-variable">
                    <span className="ic-plus">+</span> More
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="wrapper_input_template mb-4 pb-3" style={{ position: "relative" }}>
            <div className="d-flex align-items-center mb-2">
              <H4 color="#42526E" fontWeight="700" className="cl-neutral400">
                Buttons
              </H4>
              <div className="optional ms-2 cl-neutral100">Optional</div>
            </div>
            <div className="cl-neutral100 mb-3" style={{ fontSize: "14px" }}>
              Create up to 2 buttons that let customers respond to your message or take action.
            </div>
            <div className="d-flex flex-column">
              <div className="me-4">
                <ButtonProject
                  style={{ width: "150px" }}
                  onClick={() => {
                    setDropdownButtons(!dropdownButtons);
                  }}
                >
                  <label className="margin-right-10 styleDropdwown">
                    {isOptionButtons ? isOptionButtons.name : "None"}
                  </label>
                  <Icon src={Svg.chevron_right_2.default} />
                </ButtonProject>
                {dropdownButtons && (
                  <DropdownV2
                    styleDropdwown="styleDropdwown"
                    data={opsiButton}
                    handleClick={(i) => {
                      handlesetOptionButtons(i);
                    }}
                  />
                )}
              </div>
              {/* header text */}
              {isOptionButtons.value === "quick_reply" && (
                <div className="w-100 box-extra-button mt-4">
                  {isPrefButton &&
                    isPrefButton.map((res, index) => {
                      return (
                        <div className="col-sm-6 col-md-4 wrapp_input_button mb-3">
                          <label>Button Text</label>
                          <input
                            style={{ borderRadius: "5px", paddingRight: "2rem" }}
                            required={true}
                            type="text"
                            value={res?.display}
                            onChange={(e) =>
                              setChangeButtonOptions({
                                display: e.target.value,
                                content: res.content,
                                index: index,
                              })
                            }
                            placeholder="Enter text here"
                            error=""
                            className="form-control cl-neutral100"
                            maxLength={20}
                          />
                          <span className="count-char">{res?.display?.length}/20</span>
                        </div>
                      );
                    })}
                  <div
                    className={`${isErrorButtonText ? "" : "d-none"
                      } d-flex align-items-center box-info info-required`}
                  >
                    <img src={AlertTriangle}></img>
                    <span className="ms-2">Please fill every field with valid value!</span>
                  </div>
                  <div
                    onClick={handleAddOtherButton}
                    className={`mt-2 mb-2 btn-secondary-template`}
                    style={{ width: "200px" }}
                  >
                    + Add Another Button
                  </div>
                </div>
              )}
              {isOptionButtons.value === "call_to_action" && (
                <div className="w-100 box-extra-button mt-4">
                  {isPrefButton &&
                    isPrefButton.map((res, index) => {
                      return (
                        <div key={index} className="row">
                          <div className="col-sm-6 col-md-4 wrapp_input_button">
                            <label>Type of Action</label>
                            <input
                              style={{ borderRadius: "5px", paddingRight: "2rem" }}
                              required={true}
                              type="text"
                              placeholder="url"
                              error=""
                              value={res?.type}
                              // onChange={setChangeButtonOptions}
                              disabled
                              className="form-control cl-neutral100"
                            />
                            {/* <span className="count-char">1/20</span> */}
                          </div>
                          <div className="col-sm-6 col-md-4 wrapp_input_button">
                            <label>Button Text</label>
                            <input
                              style={{ borderRadius: "5px", paddingRight: "2rem" }}
                              required={true}
                              type="text"
                              placeholder="Enter text here"
                              defaultValue={res.display}
                              // onChange={(e)=> setTemplate_name(e.target.value)}
                              onChange={(e) =>
                                setChangeButtonOptions({
                                  display: e.target.value,
                                  content: res.content,
                                  index: index,
                                })
                              }
                              error=""
                              className="form-control cl-neutral100"
                              maxLength={20}
                            />
                            <span className="count_char_cta">{res?.display?.length}/20</span>
                          </div>
                          <div className="col-sm-6 col-md-4 wrapp_input_button">
                            <label>Website URL</label>
                            <input
                              style={{ borderRadius: "5px", paddingRight: "2rem" }}
                              required={true}
                              type="text"
                              placeholder="Enter text here"
                              defaultValue={res.content}
                              onChange={(e) =>
                                setChangeButtonOptions({
                                  display: res.display,
                                  content: e.target.value,
                                  index: index,
                                })
                              }
                              error=""
                              className="form-control cl-neutral100"
                              pattern="[Hh][Tt][Tt][Pp][Ss]?:\/\/(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::\d{2,5})?(?:\/[^\s]*)?"
                            />
                            {/* <span className="count-char">1/20</span> */}
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-md-5 px-lg-4">
          <PhoneMediaPreview previewData={isPreview} className="sticky"></PhoneMediaPreview>
        </div>
      </div>
    </div>
  );
}

export default CreateTemplateWa;
